import { Component, OnInit } from '@angular/core';
import { WorkshopDefect } from '../../models/workshop-defect.model';
import { WorkshopDefectPart } from '../../models/workshop-defect-part.model';
import { WorkshopDefectValidatorService } from '../../validators/workshop-defect-validator.service';
import { WorkshopDefectService } from '../../services/workshop-defect.service';
import { WorkshopDefectPartService } from '../../services/workshop-defect-part.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-workshop-defects-new',
    templateUrl: './workshop-defects-new.component.html',
    styleUrls: ['./workshop-defects-new.component.scss'],
    standalone: false
})
export class WorkshopDefectsNewComponent implements OnInit {

  defect: WorkshopDefect = new WorkshopDefect();
  pendingParts: WorkshopDefectPart[] = [];

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private defectValidator: WorkshopDefectValidatorService,
    private defectService: WorkshopDefectService,
    private workshopDefectPartService: WorkshopDefectPartService) { }

  ngOnInit(): void {
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if(this.defectValidator.isValid(this.defect)) {
      this.defectService.createWorkshopDefect(this.defect)
      .pipe(take(1))
      .pipe(catchError((e) => {
        if(e.status === 403 || e.status === 401){return e;}
        this.isServerError = true;
        return e;
      }))
      .subscribe((created: WorkshopDefect) => {
        if(!created || !created.id) {
          return;
        }
        this.assignPendingParts(created.id, 0);
      })
    } else {
      this.isError = true;
    }
  }

  /**
   * Replays the parts picked before the defect existed, one at a time, against the real
   * assignPart endpoint now that it does. Sequential rather than parallel so an insufficient-
   * stock refusal on one part doesn't race the level lock the next part's own goods-out is
   * about to take. Any individual failure is surfaced but doesn't stop the rest, or stop the
   * user reaching the edit page - they can retry a failed part from there.
   */
  assignPendingParts(workshopDefectId: number, index: number): void {
    if(index >= this.pendingParts.length) {
      // Straight to the edit page, not the list - fitters and further parts can only be
      // attached to a defect that already exists.
      window.location.href = '/workshop/defects/edit/' + workshopDefectId;
      return;
    }

    const part = this.pendingParts[index];

    this.workshopDefectPartService.assignPart(workshopDefectId, part.productId, part.qty)
    .pipe(take(1))
    .pipe(catchError((e) => {
      alert((part.product ? part.product.name : 'A part') + ' could not be assigned: ' +
        (e && e.error && e.error.message ? e.error.message : 'unknown error.'));
      return [null];
    }))
    .subscribe(() => {
      this.assignPendingParts(workshopDefectId, index + 1);
    });
  }

}
